import TextField from "../../../components/fields/textField/TextField.vue";
import { UnidadePrimariaService } from "../../../services/UnidadePrimariaService";
import Breadcrumb from "../../../components/breadcrumbs/Breadcrumb.vue";

export default {
    name: "EditarUnidadePrimaria",
    components: {
        TextField,
        Breadcrumb
    },
    data: () => ({
        breadcrumbs: [
            {
                text: 'Página Inicial',
                disabled: false,
                href: '/',
            },
            {
                text: 'Gerenciamento de Unidades Primárias',
                disabled: false,
                href: '/gerenciar-unidades-primarias',
            },
            {
                text: 'Editar Unidade Primária',
                disabled: true
            }
        ],
        unidade_primaria: {
            id: null,
            valor_total: '',
        },
        loading: false,
    }),
    created() {
        this.carregarUnidadePrimaria(this.$route.params.id);
    },
    methods: {
        async carregarUnidadePrimaria(id) {
            try {
                const response = await UnidadePrimariaService.show(id);

                if (response) {
                    const data = response.data;

                    this.unidade_primaria.id = data.id;
                    this.unidade_primaria.valor_total = data.valor_total;
                    
                } else {
                    console.error('Não foi possível carregar os dados da Entidade.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao carregar os dados da Entidade:', error);
            }
        },
        submitForm() {
            this.$refs.form.validate();
            if (!this.$refs.form.$invalid) {
              this.salvarUnidadePrimaria();
            }
            this.loading = false;
        },
        async salvarUnidadePrimaria() {

            const isValid = this.$refs.form.validate();

            if (!isValid) {
                return false;
            }

            this.loading = true;

            const formData = new FormData();

            formData.append("valor_total", this.unidade_primaria.valor_total);

            await UnidadePrimariaService.update(this.unidade_primaria.id, formData);
        }
    }
};
